// Mock data for Sellers management module

export const sellersKPIs: Record<string, any> = {
  totalSellers: { value: 1284, delta: '+5.2%', trend: 'up' },
  activeSellers: { value: 1156, delta: '+3.8%', trend: 'up' },
  blockedSellers: { value: 23, delta: '-12%', trend: 'down' },
  totalActiveOrders: { value: 892, delta: '+8.1%', trend: 'up' },
  totalProducts: { value: 45678, delta: '+2.4%', trend: 'up' },
  revenue7d: { value: 124500, delta: '+6.7%', trend: 'up' },
};

export const sellers: Record<string, any>[] = [
  {
    id: 'sel-001',
    name: 'TechVault India',
    email: 'ops@techvault.in',
    workspaceId: 'WS-TV-0891',
    plan: 'Platinum',
    totalProducts: 5234,
    activeOrders: 234,
    revenue30d: 18920,
    inventoryAlerts: 8,
    disputes: 2,
    syncStatus: 'HEALTHY',
    status: 'Active',
    joinedDate: '2024-03-15',
    marketplaces: ['Amazon', 'Flipkart', 'Meesho'],
    avatar: 'TV',
  },
  {
    id: 'sel-002',
    name: 'FashionHub',
    email: 'admin@fashionhub.com',
    workspaceId: 'WS-FH-1204',
    plan: 'Gold',
    totalProducts: 3890,
    activeOrders: 187,
    revenue30d: 14230,
    inventoryAlerts: 15,
    disputes: 5,
    syncStatus: 'WARNING',
    status: 'Active',
    joinedDate: '2024-06-22',
    marketplaces: ['Amazon', 'Flipkart'],
    avatar: 'FH',
  },
  {
    id: 'sel-003',
    name: 'HomeEssentials Co',
    email: 'hello@homeessentials.co',
    workspaceId: 'WS-HE-0567',
    plan: 'Silver',
    totalProducts: 1245,
    activeOrders: 56,
    revenue30d: 4520,
    inventoryAlerts: 3,
    disputes: 0,
    syncStatus: 'HEALTHY',
    status: 'Active',
    joinedDate: '2024-09-10',
    marketplaces: ['Flipkart'],
    avatar: 'HE',
  },
  {
    id: 'sel-004',
    name: 'GadgetWorld',
    email: 'support@gadgetworld.in',
    workspaceId: 'WS-GW-0334',
    plan: 'Platinum',
    totalProducts: 8920,
    activeOrders: 412,
    revenue30d: 32100,
    inventoryAlerts: 22,
    disputes: 8,
    syncStatus: 'HEALTHY',
    status: 'Active',
    joinedDate: '2023-11-05',
    marketplaces: ['Amazon', 'Flipkart', 'Wish'],
    avatar: 'GW',
  },
  {
    id: 'sel-005',
    name: 'StyleStreet',
    email: 'biz@stylestreet.in',
    workspaceId: 'WS-SS-0782',
    plan: 'Gold',
    totalProducts: 2456,
    activeOrders: 89,
    revenue30d: 7890,
    inventoryAlerts: 5,
    disputes: 1,
    syncStatus: 'FAILED',
    status: 'Warning',
    joinedDate: '2024-01-18',
    marketplaces: ['Amazon', 'Meesho'],
    avatar: 'SS',
  },
  {
    id: 'sel-006',
    name: 'AutoParts Direct',
    email: 'ops@autoparts.in',
    workspaceId: 'WS-AP-0123',
    plan: 'Silver',
    totalProducts: 4567,
    activeOrders: 145,
    revenue30d: 11200,
    inventoryAlerts: 12,
    disputes: 3,
    syncStatus: 'WARNING',
    status: 'Active',
    joinedDate: '2024-04-30',
    marketplaces: ['Amazon', 'Flipkart'],
    avatar: 'AP',
  },
  {
    id: 'sel-007',
    name: 'BookBazaar',
    email: 'hello@bookbazaar.com',
    workspaceId: 'WS-BB-0456',
    plan: 'Free',
    totalProducts: 890,
    activeOrders: 23,
    revenue30d: 1890,
    inventoryAlerts: 0,
    disputes: 0,
    syncStatus: 'HEALTHY',
    status: 'Active',
    joinedDate: '2025-01-12',
    marketplaces: ['Flipkart'],
    avatar: 'BB',
  },
  {
    id: 'sel-008',
    name: 'KitchenKing',
    email: 'admin@kitchenking.in',
    workspaceId: 'WS-KK-0678',
    plan: 'Gold',
    totalProducts: 3120,
    activeOrders: 167,
    revenue30d: 9870,
    inventoryAlerts: 7,
    disputes: 2,
    syncStatus: 'HEALTHY',
    status: 'Paused',
    joinedDate: '2024-07-03',
    marketplaces: ['Amazon', 'Flipkart', 'Meesho'],
    avatar: 'KK',
  },
  {
    id: 'sel-009',
    name: 'FakeGoods Ltd',
    email: 'info@fakegoods.xyz',
    workspaceId: 'WS-FG-0999',
    plan: 'Free',
    totalProducts: 45,
    activeOrders: 0,
    revenue30d: 0,
    inventoryAlerts: 0,
    disputes: 14,
    syncStatus: 'FAILED',
    status: 'Blocked',
    joinedDate: '2025-02-01',
    marketplaces: ['Wish'],
    avatar: 'FG',
  },
  {
    id: 'sel-010',
    name: 'PetSupply Hub',
    email: 'ops@petsupplyhub.in',
    workspaceId: 'WS-PS-0211',
    plan: 'Silver',
    totalProducts: 1678,
    activeOrders: 78,
    revenue30d: 5430,
    inventoryAlerts: 4,
    disputes: 1,
    syncStatus: 'HEALTHY',
    status: 'Active',
    joinedDate: '2024-08-19',
    marketplaces: ['Amazon', 'Flipkart'],
    avatar: 'PS',
  },
  {
    id: 'sel-011',
    name: 'SportsZone',
    email: 'team@sportszone.in',
    workspaceId: 'WS-SZ-0345',
    plan: 'Gold',
    totalProducts: 4210,
    activeOrders: 198,
    revenue30d: 15670,
    inventoryAlerts: 9,
    disputes: 3,
    syncStatus: 'HEALTHY',
    status: 'Active',
    joinedDate: '2024-02-28',
    marketplaces: ['Amazon', 'Flipkart', 'Meesho'],
    avatar: 'SZ',
  },
  {
    id: 'sel-012',
    name: 'CraftCorner',
    email: 'hello@craftcorner.in',
    workspaceId: 'WS-CC-0890',
    plan: 'Free',
    totalProducts: 320,
    activeOrders: 12,
    revenue30d: 980,
    inventoryAlerts: 1,
    disputes: 0,
    syncStatus: 'HEALTHY',
    status: 'Active',
    joinedDate: '2025-01-25',
    marketplaces: ['Meesho'],
    avatar: 'CC',
  },
];

// Seller detail mock data
export const sellerDetailData: Record<string, any> = {
  kpis: {
    totalProducts: { value: 5234, delta: '+2.1%' },
    activeOrders: { value: 234, delta: '+12.3%' },
    ordersToday: { value: 18, delta: '+5.9%' },
    revenue30d: { value: 18920, delta: '+8.4%' },
    inventoryAlerts: { value: 8, delta: '-25%' },
    syncFailures: { value: 1, delta: '-50%' },
    refundRate: { value: 2.3, delta: '-0.4%' },
    avgFulfillment: { value: '1.8d', delta: '-0.2d' },
  },

  revenueMonthly: [
    { month: 'Aug', revenue: 12400, refunds: 320 },
    { month: 'Sep', revenue: 14200, refunds: 410 },
    { month: 'Oct', revenue: 13800, refunds: 280 },
    { month: 'Nov', revenue: 16500, refunds: 520 },
    { month: 'Dec', revenue: 21200, refunds: 680 },
    { month: 'Jan', revenue: 18920, refunds: 390 },
  ],

  marketplaceRevenue: [
    { marketplace: 'Amazon', revenue: 9800, pct: 52 },
    { marketplace: 'Flipkart', revenue: 6400, pct: 34 },
    { marketplace: 'Meesho', revenue: 2720, pct: 14 },
  ],

  orders: [
    { id: 'ORD-8901', product: 'Wireless Earbuds Pro', marketplace: 'Amazon', qty: 2, amount: 2490, status: 'Shipped', date: '2026-01-09' },
    { id: 'ORD-8902', product: 'USB-C Hub 7-in-1', marketplace: 'Flipkart', qty: 1, amount: 1890, status: 'Processing', date: '2026-01-09' },
    { id: 'ORD-8903', product: 'Laptop Stand Aluminum', marketplace: 'Amazon', qty: 1, amount: 3450, status: 'Delivered', date: '2026-01-08' },
    { id: 'ORD-8904', product: 'Mechanical Keyboard', marketplace: 'Meesho', qty: 1, amount: 4200, status: 'Shipped', date: '2026-01-08' },
    { id: 'ORD-8905', product: 'Phone Case Bundle x3', marketplace: 'Amazon', qty: 3, amount: 890, status: 'Processing', date: '2026-01-09' },
    { id: 'ORD-8906', product: 'Webcam 1080p', marketplace: 'Flipkart', qty: 1, amount: 2100, status: 'Returned', date: '2026-01-07' },
    { id: 'ORD-8907', product: 'Bluetooth Speaker', marketplace: 'Amazon', qty: 1, amount: 1650, status: 'Delivered', date: '2026-01-07' },
    { id: 'ORD-8908', product: 'Mouse Pad XL', marketplace: 'Meesho', qty: 2, amount: 560, status: 'Delivered', date: '2026-01-06' },
  ],

  inventory: [
    { sku: 'SKU-TV-001', name: 'Wireless Earbuds Pro', stock: 234, lowThreshold: 50, lastSync: '2026-01-09T14:30:00Z', status: 'OK' },
    { sku: 'SKU-TV-002', name: 'USB-C Hub 7-in-1', stock: 12, lowThreshold: 30, lastSync: '2026-01-09T14:30:00Z', status: 'LOW' },
    { sku: 'SKU-TV-003', name: 'Laptop Stand Aluminum', stock: 89, lowThreshold: 20, lastSync: '2026-01-09T14:30:00Z', status: 'OK' },
    { sku: 'SKU-TV-004', name: 'Mechanical Keyboard', stock: 5, lowThreshold: 15, lastSync: '2026-01-09T12:00:00Z', status: 'CRITICAL' },
    { sku: 'SKU-TV-005', name: 'Phone Case Bundle', stock: 456, lowThreshold: 100, lastSync: '2026-01-09T14:30:00Z', status: 'OK' },
    { sku: 'SKU-TV-006', name: 'Webcam 1080p', stock: 0, lowThreshold: 10, lastSync: '2026-01-08T18:00:00Z', status: 'OUT' },
    { sku: 'SKU-TV-007', name: 'Bluetooth Speaker', stock: 67, lowThreshold: 25, lastSync: '2026-01-09T14:30:00Z', status: 'OK' },
    { sku: 'SKU-TV-008', name: 'Mouse Pad XL', stock: 18, lowThreshold: 20, lastSync: '2026-01-09T10:00:00Z', status: 'LOW' },
  ],

  catalogSummary: {
    totalSKUs: 5234,
    productTypes: [
      { type: 'Electronics', count: 2100 },
      { type: 'Accessories', count: 1800 },
      { type: 'Cables & Adapters', count: 890 },
      { type: 'Cases & Covers', count: 444 },
    ],
    needsMapping: 34,
    recentlyUpdated: 128,
  },

  syncLogs: [
    { id: 1, marketplace: 'Amazon', status: 'COMPLETED', startedAt: '2026-01-09T14:30:00Z', duration: '4m 12s', products: 3200, errors: 0 },
    { id: 2, marketplace: 'Flipkart', status: 'COMPLETED', startedAt: '2026-01-09T12:00:00Z', duration: '3m 45s', products: 1800, errors: 2 },
    { id: 3, marketplace: 'Meesho', status: 'FAILED', startedAt: '2026-01-09T10:00:00Z', duration: '1m 22s', products: 0, errors: 1 },
    { id: 4, marketplace: 'Amazon', status: 'COMPLETED', startedAt: '2026-01-08T14:30:00Z', duration: '4m 08s', products: 3198, errors: 0 },
    { id: 5, marketplace: 'Flipkart', status: 'COMPLETED', startedAt: '2026-01-08T12:00:00Z', duration: '3m 50s', products: 1795, errors: 1 },
  ],

  notifications: [
    { id: 1, type: 'warning', title: 'Low stock alert', message: '8 SKUs below minimum threshold', date: '2026-01-09T15:00:00Z', read: false },
    { id: 2, type: 'info', title: 'Sync completed', message: 'Amazon catalog sync completed successfully', date: '2026-01-09T14:45:00Z', read: true },
    { id: 3, type: 'error', title: 'Sync failed', message: 'Meesho sync failed — API timeout', date: '2026-01-09T10:02:00Z', read: false },
    { id: 4, type: 'success', title: 'Order milestone', message: 'Crossed 10,000 lifetime orders', date: '2026-01-08T09:00:00Z', read: true },
    { id: 5, type: 'info', title: 'Plan renewal', message: 'Platinum plan renewal due in 15 days', date: '2026-01-07T08:00:00Z', read: true },
  ],

  activityLog: [
    { id: 1, action: 'Orders processed', detail: '18 orders processed today', timestamp: '2026-01-09T16:00:00Z', icon: 'order' },
    { id: 2, action: 'Sync completed', detail: 'Amazon catalog sync — 3,200 products', timestamp: '2026-01-09T14:45:00Z', icon: 'sync' },
    { id: 3, action: 'Inventory updated', detail: 'Bulk stock update for 45 SKUs', timestamp: '2026-01-09T11:30:00Z', icon: 'inventory' },
    { id: 4, action: 'Sync failed', detail: 'Meesho sync — API timeout', timestamp: '2026-01-09T10:02:00Z', icon: 'error' },
    { id: 5, action: 'Plan change', detail: 'Upgraded from Gold to Platinum', timestamp: '2026-01-05T09:00:00Z', icon: 'plan' },
    { id: 6, action: 'New marketplace', detail: 'Connected Meesho marketplace', timestamp: '2025-12-20T14:00:00Z', icon: 'marketplace' },
    { id: 7, action: 'Sync completed', detail: 'Flipkart catalog sync — 1,800 products', timestamp: '2025-12-19T12:15:00Z', icon: 'sync' },
  ],
};
